import { AppDispatch } from "@src/store";
import { impersonateActions } from "@src/store/slices/impersonate";
import { loginActions } from "@src/store/slices/login";
import { User } from "@src/store/slices/login/types";
import { decryptToken } from "@src/utils/decryptToken";
import { sucessfulResponseValidation } from "@src/utils/sucessfulResponseValidation";
import jwtDecode from "jwt-decode";

import { api } from "./api";

export const activateImpersonate = (userId: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(
      impersonateActions.controlView({ isLoadingActivateImpersonate: true, hasError: false }),
    );

    const response = await api.post("/activate/impersonate", { id: userId });

    if (!sucessfulResponseValidation(response.status))
      throw new Error(response.data?.message || "Erro ao ativar impersonate.");

    const jwtToken = decryptToken(response.data.token);
    const userImpersonate = jwtDecode<User>(jwtToken);

    dispatch(
      loginActions.controlData({
        token: response.data.token,
        user: {
          id: userImpersonate.id,
          name: userImpersonate.name,
          email: userImpersonate.email,
          roles: userImpersonate.roles,
          privacy: userImpersonate.privacy,
          tenant: userImpersonate.tenant,
          customer: userImpersonate.customer,
          customerName: userImpersonate.customerName,
          departmentId: userImpersonate.departmentId,
          departmentName: userImpersonate.departmentName,
          viewMode: userImpersonate.viewMode,
          userInViewMode: userImpersonate.userInViewMode,
          phone: userImpersonate.phone,
          cpf: userImpersonate.cpf,
        },
      }),
    );

    dispatch(
      impersonateActions.controlView({
        isLoadingActivateImpersonate: false,
        hasError: false,
      }),
    );

    return {
      tokenImpersonate: response.data.token,
      userImpersonate,
    };
  } catch (err: any) {
    dispatch(
      impersonateActions.controlView({
        isLoadingActivateImpersonate: false,
        hasError: true,
        msgError: err.response.data.message,
      }),
    );

    throw err;
  }
};

export const disableImpersonate = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(
      impersonateActions.controlView({ isLoadingDisableImpersonate: true, hasError: false }),
    );

    const response = await api.post("/disable/impersonate");

    if (!sucessfulResponseValidation(response.status))
      throw new Error(response.data?.message || "Erro ao desativar impersonate.");

    const jwtToken = decryptToken(response.data.token);
    const originalUser = jwtDecode<User>(jwtToken);

    dispatch(
      loginActions.controlData({
        token: response.data.token,
        user: {
          id: originalUser.id,
          name: originalUser.name,
          email: originalUser.email,
          roles: originalUser.roles,
          privacy: originalUser.privacy,
          tenant: originalUser.tenant,
          customer: originalUser.customer,
          customerName: originalUser.customerName,
          departmentId: originalUser.departmentId,
          departmentName: originalUser.departmentName,
          viewMode: originalUser.viewMode,
          userInViewMode: originalUser.userInViewMode,
          phone: originalUser.phone,
          cpf: originalUser.cpf,
        },
      }),
    );

    dispatch(
      impersonateActions.controlView({ isLoadingDisableImpersonate: false, hasError: false }),
    );

    return {
      originalToken: response.data.token,
      originalUser,
    };
  } catch (err: any) {
    dispatch(
      impersonateActions.controlView({
        isLoadingDisableImpersonate: false,
        hasError: true,
        msgError: err.response.data.message,
      }),
    );

    throw err;
  }
};
